import { $analytics } from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default function analyticsFactory(eventCategory) {
  return {
    methods: {
      trackEvent(action, label, category = eventCategory) {
        $analytics.eventTrack(action, { category, label, action });
      }
    }
  };
}
